import React, { Component } from 'react';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: this.props.popup && this.props.popup.enable
    }
  }

  closeModal(e){
    e.preventDefault()
    this.setState({
      modalOpen: false
    })
  }

  render() {
    return (
      <div>
        <div className="visible-xs-block">
          <div className="home-background">
            <div className="text-center mg-top-sm">
              <br />
            <img alt="logo" src="/cafe-wide.jpg" />
              <br />
              <br />
              <p>Order your school lunch online</p>
              <p>Coffee now available at selected schools!</p>
            </div>
            <div className="row phone-bottom">

              <div className="col-xs-6">
                <a href="#/signup" className="btn btn-default btn-block">Signup</a>
              </div>

              <div className="col-xs-6">
                <a href="#/login" className="btn btn-primary btn-block">Login</a>
              </div>

            </div>
          </div>


        </div>

        <div className="hidden-xs">
          <div className="row">
            <div className="col-sm-6 home-col bg"></div>
            <div className="col-sm-6 home-col text-center">
              <br />
              <img alt="logo" src="/cafe-wide.jpg" />
              <br />
              <br />
              <p>Order your school lunch online</p>
              <p>Coffee now available at selected schools!</p>
              <h3 className="mg-top-sm">Available At:</h3>
              <div style={{display: 'inline-block'}}>
                {/* <p>
                  Palmerston North Girls High School <span className="label label-info">Morning Tea</span> <span className="label label-primary">Lunch</span> <span className="label label-warning">Coffee</span>
                </p> */}
                <p>
                  Feilding High School <span className="label label-info">Morning Tea</span> <span className="label label-primary">Lunch</span>
                </p>
                <p>
                  Lytton St School Feilding, Tuesdays/Thursdays - Teachers only <span className="label label-primary">Lunch</span>
                </p>
                {/* <p>
                  North St School Feilding, Thursdays <span className="label label-primary">Lunch</span>
                </p> */}
                {/* <p>
                  Feilding Intermediate School, Tuesdays <span className="label label-primary">Lunch</span>
                </p> */}
                {/* <p>
                  Manchester Street School, Mondays/Wednesdays <span className="label label-primary">Lunch</span>
                </p> */}
                { this.props.promo && this.props.promo.enable ? (
                  <p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSfQBgHWVVF6HaoAc1Y5v8X_lFAas6TTJwZWrKpZvfDysIxN2Q/viewform?usp=sf_link">
                      {this.props.promo.text}
                    </a>
                </p>
                ) : null}
              </div>
              <div className="row mg-top-lg">
                <div className="col-xs-6 col-xs-offset-3">
                  <a href="#/login" className="btn btn-primary btn-block">Login</a>
                  <br />
                  <a href="#/signup" className="btn btn-default btn-block">Signup</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"warning-modal" + (this.state.modalOpen ? ' active' : '')}>
          <div className="body">
            <h1>Please note</h1>
            <br />
            <div dangerouslySetInnerHTML=
              {{__html: this.props.popup && this.props.popup.message.replace(/\n/g,'<br />')}}></div>
            <br />
            <button className="btn btn-primary" onClick={this.closeModal.bind(this)}>
              Ok
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js